import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { ProfileSetupService } from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import { AppConfig } from '@mpt-fo/common/shared/config/app-config';
import { ModalType } from "@mpt-fo/common/kamona/model/kamonal-model";
import { LocalStorageService } from "@mpt-fo/common/core/services/local-storage.service";
import { StorageKeys } from "@mpt-fo/common/shared/models/storage-keys";
import { LocationHelper } from "@mpt-fo/common/core/helpers/location.helper";
import { DataLayerService, LocationRequestEvents } from "@mpt-fo/common/core/services/data-layer-service.service";
import { ScreenManagerService } from "@mpt-fo/common/core/services/screen-manager.service";
import { RouteTrackerService } from "@mpt-fo/common/core/services/route-tracker.service";


@Component({
  selector: "ng-mf-login-request-location",
  templateUrl: "./login-request-location.component.html",
  styleUrls: ["./login-request-location.component.scss"]
})

export class LoginRequestLocationComponent implements OnInit {
  readonly ModalType = ModalType;

  termsAndConditions: {content: string};
  showPrivacyModal = false;
  showTermsModal = false;
  showAlertModal: "unauthorized" | "rejected" | "unsupported";
  isMobile: boolean;
  rejectedRequestMessage: string;


  constructor(
    private profileService: ProfileSetupService,
		private router: Router,
		private config: AppConfig,
    private localStorage: LocalStorageService,
		private locationHelper: LocationHelper,
    private dataLayerService: DataLayerService,
		private screenManager: ScreenManagerService,
    private routeTrackerService: RouteTrackerService,
  ) {}

  get isLocationAccessMandatory() {
		return this.config.ENABLE_MANDATORY_LOGIN_LOCATION_ACCESS;
	}

  get isGeolocationSupported() {
    return this.locationHelper.hasBrowserSupport();
  }

  get previouslyAccessedRoute() {
    const { previousRoute } = this.routeTrackerService.getRoutes();
    return previousRoute;
  }

  ngOnInit() {
    this.getTermsAndConditions();
    this.handleCheckLocationAccess();

    this.isMobile = this.screenManager.isMobile();
  }

  async handleRequestPermission() {
    this.dataLayerService.logEventWithData(LocationRequestEvents.initiated);
    
    if(this.isGeolocationSupported) {
      try {
        const {latitude, longitude} = await this.locationHelper.getCoordinates();

        this.dataLayerService.logEventWithData(LocationRequestEvents.success, {latitude, longitude});

        this.localStorage.save(StorageKeys.LOCATION_PERMISSION_RESPONSE, 'YES');
        
        this.router.navigateByUrl(this.previouslyAccessedRoute);
      } catch(err) {
        this.dataLayerService.logEventWithData(LocationRequestEvents.failed, {error_message: "User rejected request"});
        this.handleRejectRequest();
      }
    } else {
      // please use a supported browser
      this.dataLayerService.logEventWithData(LocationRequestEvents.failed, {error_message: "Unsupported browser"});
      this.showAlertModal = 'unsupported';
    }
  }


  handleDeniedLocation() {
    this.handleRequestPermission();
    this.showAlertModal = undefined;
  }

  handleRejectRequest() {
    const hasUserRejectedPreviously = this.localStorage.get(StorageKeys.LOCATION_PERMISSION_RESPONSE) === 'NO';

    if(hasUserRejectedPreviously) {
      this.rejectedRequestMessage = `Click the "Site Information" icon at the top left of your browser's URL tab. Then, select the "Reset permissions" button under the "Location" section, and reload the page.`;
    } else {
      this.rejectedRequestMessage = `We can not authorise access to your account until we’ve verified your location. Give Moniepoint access to your app location to continue.`;
    }

    if(this.isLocationAccessMandatory) {
      this.showAlertModal = 'rejected';
    } else {
      this.router.navigateByUrl(this.previouslyAccessedRoute);
    }

    this.localStorage.save(StorageKeys.LOCATION_PERMISSION_RESPONSE, 'NO');
  }


  async handleCheckLocationAccess() {
    const hasPermission = await this.locationHelper.hasPermission();

    if(hasPermission) {
      this.router.navigateByUrl(this.previouslyAccessedRoute);
    }
  }

  goToLogin() {
    this.profileService.routeToLogin();
  }

  openPrivacy() {
    this.showPrivacyModal = true;
  }

  handleClosePrivacyModal(){
    this.showPrivacyModal = false;
  }

  openTermsAndConditions() {
    this.showTermsModal = true;

  }

  handleCloseTermsModal(){
    this.showTermsModal = false;
  }

  async getTermsAndConditions() {
    this.termsAndConditions = await this.profileService.termsAndConditions();
  }
}